export default __webpack_public_path__ + "static/media/virtualBox.88ae6578.png";